import type { LegendSymbol } from "../types";

import { LegendSymbolIcon } from "./LegendSymbolIcon";

import "./LayerLegend.css";

export function LayerLegend({ symbols }: { symbols: LegendSymbol[] }) {
  return (
    <div className="layer-legend">
      {symbols.map((symbol, index) => (
        <div className="legend-symbol" key={`${symbol.display_name}-${index}`}>
          <LegendSymbolIcon symbol={symbol} />
          <span>{symbol.display_name || ""}</span>
        </div>
      ))}
    </div>
  );
}
